<script setup>
    import { useProjectListStore } from '@/lib/stores/project-list-store';
    const store = useProjectListStore();

    const removeFilter = (filter) => {
        store.removeFilter(filter.id, filter.name);
    };
</script>


<template>
    <div class="flex-container-filter">
        <div>
            <button class="btn-filter tag-text text--medium" v-for="filter in store.filters" :key="filter.id" @click.prevent="removeFilter(filter)">
                {{ filter.name }}
                <span class="icon icon--close-24"></span>
            </button>
            <button v-if="store?.filters?.length > 0" class="btn-reset-filter tag-text text--medium" @click.prevent="store.resetFilters()">Nullstill filter</button>
        </div>
    </div>
</template>
